import MegaMenuView from "./MegaMenuView";
import { usePushNotificationsContext } from "contexts/PushNotificationsProvider";
import usePopUpsV2 from "components/PopUpManagerV2/hooks/usePopUpsV2";
import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";
import { useWebStoreContext } from "contexts";
import { useEffect } from "react";

export const PushBanner = ({ from }: { from: string }) => {
	const { isSupported, isSubscribed, permission, subscribe, pushLocalState } =
		usePushNotificationsContext();
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const { authToken } = useWebStoreContext();
	const isLoggedIn = Boolean(authToken?.value);
	const neverShowPopup = Boolean(pushLocalState?.neverShowPopup);
	const initialPopupShown = Boolean(pushLocalState?.initialPopupShown);
	const { open } = usePopUpsV2();

	const notificationsDisabled = !isSubscribed || permission !== "granted";
	const shouldShowBanner =
		isLoggedIn &&
		isSupported &&
		notificationsDisabled &&
		// Show when the user explicitly dismissed our popup ("Not now")
		// or when browser permission is currently denied, so we still
		// offer a manual path from the Mega Menu.
		// Also show when initial popup already ran, permission is granted,
		// and user is still not subscribed, so they can re-enable from banner.
		(Boolean(neverShowPopup) ||
			permission === "denied" ||
			(initialPopupShown &&
				(permission === "granted" || permission === "default")));

	useEffect(() => {
		if (shouldShowBanner) {
			reportPlaygamiEvent("tp.web_frontend", {
				event_name: "pwa_notification_enable_banner_shown",
				event_type: "pwa_notification_enable_banner",
				action: "shown",
				source: "pwa_push",
				page_location: from
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [shouldShowBanner]);

	const handleMainClick = async () => {
		if (!isLoggedIn) {
			return;
		}

		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "pwa_notification_enable_banner_click",
			event_type: "pwa_notification_enable_banner",
			action: "clicked",
			source: "pwa_push",
			page_location: from
		});

		await subscribe();

		const effectivePermission: NotificationPermission | "unsupported" =
			typeof Notification === "undefined"
				? permission
				: Notification.permission;

		if (effectivePermission === "denied") {
			open({
				variant: "push-info-popup",
				id: "push-info-popup",
				replaceIfExists: true
			});
		}
	};

	if (!shouldShowBanner) {
		return null;
	}

	return (
		<>{from === "mega-menu" && <MegaMenuView onClick={handleMainClick} />}</>
	);
};
